// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon__icon--YFXFc","flipped":"Icon__flipped--I7j8g","badge":"Icon__badge--y-iNY"};